<mpro-dropdown
  title="Spending group"
  [inputValue]="getInputValue()"
  (openDropdownAction)="onDropdownOpened()"
  *ngIf="authService.permissions$ | async as plan"
  [info]="'Export limited to 6 spending groups simultaneously'"
  [showInfo]="multiSelect"
>
  <div *ngIf="!addNew" class="dropdown-content-wrapper">
    <div #tooltip [hidden]="true">
      <mpro-tooltip [options]="tooltipOptions"></mpro-tooltip>
    </div>
    <div class="sections-wrapper">
      <div class="section-wrapper">
        <div class="section" id="userGroups" *ngIf="!plan.isFreemium">
          <mpro-dropdown-item
            class="title-label"
            [isDropdown]="true"
            [dropdownOpen]="userGroupsDropdownOpened"
            (itemClicked)="userGroupsClicked()"
            (arrowClicked)="userGroupsClicked()"
            [leftText]="'Your groups'"
          ></mpro-dropdown-item>
          <ng-container *ngIf="userGroupsDropdownOpened">
            <mpro-dropdown-item
              *ngFor="let g of userGroups"
              [actions]="true"
              [leftText]="g.compactDisplayValue()"
              [middleText]="g.name"
              (itemClicked)="onGroupClicked(g, false)"
              (editClicked)="onEditClicked(g)"
              (deleteClicked)="onDeleteClicked(g)"
              [selected]="isGroupSelected(g)"
            ></mpro-dropdown-item>
          </ng-container>
          <hr *ngIf="userGroups.length" />
        </div>
        <div class="section">
          <div class="title-label">Standard Groups</div>
          <ng-container *ngFor="let g of systemGroups">
            <mpro-dropdown-item
              class="system-group"
              [bgColor]="getGroupColor(g, 100)"
              [bgColorHover]="getGroupColor(g, 300)"
              [isDropdown]="!!g.subgroups.length"
              [leftText]="g.compactDisplayValue()"
              [middleText]="g.name"
              [disabled]="g.disabled || !!g.authDisabled"
              [readonly]="isSpendingGroupDisabled() && !!g.name"
              [showLock]="!!g.authDisabled"
              (itemClicked)="onGroupClicked(g, false)"
              (arrowClicked)="groupArrowClicked(g, $event)"
              [selected]="isGroupSelected(g)"
              [dropdownOpen]="g.opened"
              (mouseenter)="onMouseEnter($event, g)"
              (mouseleave)="onMouseLeave()"
            ></mpro-dropdown-item>
            <ng-container *ngIf="g.opened">
              <mpro-dropdown-item
                *ngFor="let sg of g.subgroups"
                class="system-subgroup"
                [bgColor]="getGroupColor(sg, 100)"
                [bgColorHover]="getGroupColor(sg, 300)"
                [leftText]="sg.compactDisplayValue()"
                [middleText]="sg.name"
                [disabled]="sg.disabled || !!sg.authDisabled"
                [readonly]="isSpendingGroupDisabled()"
                [showLock]="!!sg.authDisabled"
                (itemClicked)="onGroupClicked(sg, true)"
                (mouseenter)="onMouseEnter($event, sg)"
                (mouseleave)="onMouseLeave()"
                [selected]="isGroupSelected(sg)"
              ></mpro-dropdown-item>
            </ng-container>
          </ng-container>
        </div>
        <div *ngIf="!hideNew" class="new-btn-wrapper">
          <button
            blockOnClickEvent
            [condition]="plan.isFreemium || false"
            [requestCategory]="'New spending group'"
            [callback]="authService.openFreemiumRequestModal"
            class="mpro-btn mpro-btn-primary new-btn"
            (click.checkBlockEvent)="newGroup.emit(); setAddNew(true)"
            stopClickPropagation
          >
            <fa-icon [icon]="faPlus"></fa-icon>
            <span>New Spending Group</span>
            <fa-icon
              *ngIf="!authService.isLoggedIn() || plan.isFreemium"
              [icon]="faLock"
            ></fa-icon>
          </button>
        </div>
      </div>
    </div>
  </div>
  <mpro-dialog-box
    class="mpro-box"
    *ngIf="addNew"
    (save)="onSave($event)"
    (preview)="onPreview($event)"
    (cancel)="onCancel()"
    title="Create Spending Group"
    inputTitle="Name"
    subtitle="Drag the slider or enter your desired spending range in the fields below."
    [rangeFilter]="inEditSpendingGroup"
    [min]="0"
    [max]="max"
    [minInterval]="3"
    [customSteps]="customSteps"
  ></mpro-dialog-box>
</mpro-dropdown>

<mpro-delete-modal
  [(open)]="isDeleteModalOpen"
  [resourceName]="spendingGroupForDeletion?.name || ''"
  (onDelete)="onDelete()"
>
</mpro-delete-modal>
